module.exports = __webpack_public_path__ + "img/sunlogin-2.6847a3b7.png";